import { Info } from 'lucide-react';
import { Popover } from '../../../components/Shared/Popover';
import { useTranslation } from '../../../i18n';
import { formatDays } from '../../../utils/absenceDays';
import { numberLocale } from '../../../utils/locale';

interface RoundedDaysHintProps {
  /** The value shown, already rounded by the server. */
  value: number;
  /** The exact value without rounding; null/undefined when nothing was rounded — then nothing renders. */
  unrounded?: number | null;
}

/** Exact pro-rated values have two decimals (14,58) — one decimal would show 6,25 as "6,3". */
function formatExactDays(value: number): string {
  return value.toLocaleString(numberLocale(), { maximumFractionDigits: 2 });
}

/**
 * Info button next to a vacation figure the tenant's whole-day rounding changed (FAFD-48).
 * Rounding happens on the server; this only explains it, it never rounds itself.
 */
export function RoundedDaysHint({ value, unrounded }: RoundedDaysHintProps) {
  const { t } = useTranslation();

  if (unrounded === null || unrounded === undefined) {
    return null;
  }

  return (
    <Popover
      label={t('absences:vacation.roundedLabel')}
      trigger={<Info className="w-3.5 h-3.5" strokeWidth={2} />}
    >
      <div className="px-3 py-2 text-slate-600 tabular-nums">
        {t('absences:vacation.roundedHint', { from: formatExactDays(unrounded), to: formatDays(value) })}
      </div>
    </Popover>
  );
}
